import React from 'react';

const VerticalHero = React.lazy(() =>
  import('components/Contentful/ContentfulDynamicHero/VerticalHero'),
);
const ParallaxHero = React.lazy(() =>
  import('components/Contentful/ContentfulDynamicHero/ParallaxHero'),
);
const DynamicFeatures = React.lazy(() => import('components/DynamicFeatures'));
const ExtensionLadder = React.lazy(() => import('components/ExtensionLadder'));
const OnboardingSection = React.lazy(() => import('components/OnboardingSection'));
const CallToActionCards = React.lazy(() => import('components/Sections/CallToActionCards'));
const SocialProofSection = React.lazy(() => import('components/Sections/SocialProofSection'));
const DynamicWire = React.lazy(() => import('components/Sections/DynamicWire'));
const OverlayQuote = React.lazy(() => import('components/Core/WistiaVideo/OverlayQuote'));
const CareersGridSection = React.lazy(() => import('components/Page/Careers/Grid'));
const CareersJobListingSection = React.lazy(() => import('components/Page/Careers/JobListing'));
const ValuePropStrip = React.lazy(() => import('components/Sections/ValuePropStrip'));
const Router = React.lazy(() => import('components/Sections/Router'));
const Clamp = React.lazy(() => import('components/Sections/Clamp'));
const Bender = React.lazy(() => import('components/Sections/Bender'));
const Chisel = React.lazy(() => import('components/Sections/Chisel'));
const Hoe = React.lazy(() => import('components/Sections/Hoe'));
const Spade = React.lazy(() => import('components/Sections/Spade'));
const Sandpaper = React.lazy(() => import('components/Sections/Sandpaper'));
const AwardsNamesImages = React.lazy(() => import('components/AwardsNamesImages'));
const Benefits = React.lazy(() => import('components/Page/Careers/Benefits'));
const ComparisonCardSection = React.lazy(() =>
  import('components/Page/Comparison/ComparisonCardSection'),
);
const VideoTheaterV1 = React.lazy(() => import('components/VideoTheater/VideoTheaterV1'));
const VideoTheaterV2 = React.lazy(() => import('components/VideoTheater/VideoTheaterV2'));
const RedirectHero = React.lazy(() =>
  import('components/Page/MarketingPro/MarketingProThankYouHero'),
);
const ContentShowcase = React.lazy(() => import('components/Sections/ContentShowcase'));
const PowerTheNation = React.lazy(() => import('components/PowerTheNation'));

const ComponentMap = {
  'Power The Nation': PowerTheNation,
  Grinder: DynamicFeatures,
  Sander: OnboardingSection,
  'Call To Action Cards': CallToActionCards,
  'Comparison Cards': ComparisonCardSection,
  'Vertical Hero': VerticalHero,
  'Dynamic Wire': DynamicWire,
  Video: OverlayQuote,
  'Careers - Grid': CareersGridSection,
  'Careers - Job Listing': CareersJobListingSection,
  'Value Prop Strip': ValuePropStrip,
  'Parallax Hero': ParallaxHero,
  'Social Proof': SocialProofSection,
  Awards: AwardsNamesImages,
  Benefits,
  'Video Cards Theater': VideoTheaterV1,
  'Hero | Redirect': RedirectHero,
  'Content Showcase': ContentShowcase,
  Spade,
  Router,
  Clamp,
  Sandpaper,
  Bender,
  Chisel,
  Hoe,
  'Extension Ladder': ExtensionLadder,
  'Video Theater': VideoTheaterV2,
};

export default ComponentMap;
